// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  CanonicalAddress,
  TargetablePropertySourceV1,
} from "./types";

export default {
  id: __t.uuid(),
  get canonicalAddress() {
    return CanonicalAddress;
  },
  googlePlaceId: __t.option(__t.string()),
  googlePlacePhotoName: __t.option(__t.string()),
  imageUrl: __t.option(__t.string()),
  get source() {
    return TargetablePropertySourceV1;
  },
  externalId: __t.option(__t.string()),
  latitude: __t.option(__t.f64()),
  longitude: __t.option(__t.f64()),
  sqft: __t.option(__t.f64()),
};
